import styled from '@themes/theme'

export const MatchStatusTagWrap = styled.div`
  min-width: 43px;
  display: flex;
  align-items: center;
  justify-content: center;
  .time-icon {
    min-width: 10px;
    height: auto;
    margin-right: 2px;
    .fill {
      fill: ${props => props.theme.color.themeTxt};
    }
  }
  .live-tag, .closed-tag, .before-tag {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 100%;
    height: 18px;
    padding: 0 3px;
    border-radius: 4px;
    .txt {
      font-size: ${props => props.theme.font.small};
      font-weight: ${props => props.theme.fontW.medium};
      line-height: 18px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .live-tag {
    background: ${props => props.theme.color.modalred};
    .txt {
      color: ${props => props.theme.color.themeTxt};
      font-weight: ${props => props.theme.fontW.bold};
    }
  }
  .closed-tag {
    background: ${props => props.theme.color.modalgray};
    .txt {
      color: ${props => props.theme.color.modalBg};    
    }
  }
  .before-tag {
    background: ${props => props.theme.color.tabBg};
    .txt {
      color: ${props => props.theme.color.themeTxt};
    }
  }
`
